import { addRoute } from '../../../../utils/map';
import { useRecordGPS } from 'hooks/useRecords';
import Map from 'component/map';

/**
 * Component to render a map with GPS tracking data for a specific record.
 *
 * @param {string} uuid - The unique identifier of the record.
 */
export const MapTracking = ({ uuid }) => {
    const { gpsPoints } = useRecordGPS(uuid);

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Map
                center={[51.5074, -0.1276]}
                zoom={13}
                onCreated={(map) => {
                    addRoute(map, gpsPoints);
                }}
                style={{
                    width: '100%',
                    height: '500px',
                    margin: 0,
                    padding: 0,
                    display: 'block'
                }}
            />
        </div>
    );
};
